import {RootState} from '../../rootReducer';

export const selectCustomerBranding = (state: RootState) => state.data.customerBranding.branding;
export const selectCustomerBrandingLoadingStatus = (state: RootState) => state.data.customerBranding.loadingStatus;
